import { Component, OnInit } from '@angular/core';
import { Breadcrumb, GenerateTableColumn, GenerateTablePagination } from '../../shared/components';
import { GenericRelatorioComponent } from 'src/app/relatorio/generic-relatorio.component';
import { BeneficiariaService } from 'src/app/beneficiaria/beneficiaria.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr } from 'src/app/shared/utils';
import { NgForm } from '@angular/forms';
import { UsuarioResponse, UsuarioService } from 'src/app/usuario';
import dayjs from 'dayjs';
import { catchError, concat, distinctUntilChanged, map, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { CancelamentoMassaService } from './cancelamento-em-massa.service';
import { ContratoService } from 'src/app/contrato/contrato.service';
import { Contrato } from 'src/app/contrato/contrato.model';
import { RolesEnum } from 'src/app/core';

@Component({
    selector: 'app-cancelamento-em-massa',
    templateUrl: './cancelamento-em-massa.component.html',    
    standalone: false
})
export class CancelamentoMassaComponent extends GenericRelatorioComponent implements OnInit {

    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Configurações' },
        { label: 'Cancelamento em Massa' },
    ];

    usuario$: Observable<UsuarioResponse[]>;
    usuarioInput$ = new Subject<string>();
    user?: any;

    dataSource: any[];
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
    columns: GenerateTableColumn[] = [
        { header: '#', attr: 'index' },
        { header: 'DIO', attr: 'numeroDio' },
        { header: 'Prefixo', attr: 'prefixo' },
        { header: 'Contrato', attr: 'contrato' },            
        { header: 'Equipamento', attr: 'placa' },
        { header: 'Início Operação', attr: 'dataInicioOperacao' },   
        { header: 'Condutor', attr: 'condutor' },   
        { header: 'Status Execução', attr: 'statusExecucao' },      
    ];

    constructor(
        private usuarioService: UsuarioService,
        private contratoService: ContratoService,
        protected override beneficiariaService: BeneficiariaService,
        private cancelamentoMassaService: CancelamentoMassaService,
        protected override snackBar: MatSnackBar,
    ) {   
        super(beneficiariaService, snackBar);
    }

    ngOnInit(): void {
        this.getUsuarios();
        this.getContratos();
    }

    private getContratos() {
        this.loading = true;
        this.contratoService.getAll<Contrato>(true).subscribe({
            next: (res) => this.contratos = res.data,
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    async save(form: NgForm){
        const cancelamentoMassa = {
            dataInicio: this.filters.dataInicio ? dayjs(this.filters.dataInicio).format('YYYY-MM-DD') : '',
            dataFim: this.filters.dataFim ? dayjs(this.filters.dataFim).format('YYYY-MM-DD') : '',
            contratoId: this.filters.contrato ? this.filters.contrato.id : '',
            prefixo: this.filters.prefixo || '',
            userId: this.user ? this.user.id : '',
            firstName: this.user ? this.user.firstName : '',
            lastName: this.user ? this.user.lastName : ''
        }

        this.cancelamentoMassaService.cancelar(cancelamentoMassa).subscribe({
            next: () => {
                this.snackBar.open('Cancelamento em massa realizado com sucesso!', 'Fechar', { duration: 5000 });
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    private getUsuarios() {
        this.usuario$ = concat(
            of([]), // default items
            this.usuarioInput$.pipe(
                distinctUntilChanged(),
                tap(() => this.loading = true),
                switchMap((term) => {
                    return term ?
                        this.usuarioService.getPaginated<UsuarioResponse>(0, 20, term, RolesEnum.EMISSOR).pipe(
                                    map((res: any) => res.data as UsuarioResponse[]),
                                    catchError(() => of([])),
                                    tap(() => this.loading = false)
                                ) : new Promise(() => this.loading = false)
                })
            ) as Observable<UsuarioResponse[]>
        );
    }

}